(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["makri-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('makri-customer-reviews')) {
    customElements.define(
      'makri-customer-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.previous = this.querySelector('[data-previous]');
          this.next = this.querySelector('[data-next]');
          this.abortController = new AbortController();
          const signal = this.abortController.signal;

          this.previous.addEventListener('click', () => this.scroll(-1), { signal });
          this.next.addEventListener('click', () => this.scroll(1), { signal });
          this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        scroll(direction) {
          this.track.scrollBy({ left: this.track.clientWidth * 0.92 * direction, behavior: 'smooth' });
        }

        update() {
          const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
          this.previous.hidden = !hasOverflow;
          this.next.hidden = !hasOverflow;
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["makri-deal-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('makri-deal-products')) {
    customElements.define(
      'makri-deal-products',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.previous = this.querySelector('[data-previous]');
          this.next = this.querySelector('[data-next]');
          this.abortController = new AbortController();
          const signal = this.abortController.signal;

          this.previous.addEventListener('click', () => this.scroll(-1), { signal });
          this.next.addEventListener('click', () => this.scroll(1), { signal });
          this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        scroll(direction) {
          this.track.scrollBy({ left: this.track.clientWidth * 0.84 * direction, behavior: 'smooth' });
        }

        update() {
          const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
          this.previous.hidden = !hasOverflow;
          this.next.hidden = !hasOverflow;
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["makri-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('makri-hero')) {
    customElements.define(
      'makri-hero',
      class MakriHero extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.currentIndex = 0;

          if (this.slides.length < 2) return;

          // Gizli slaytlar lazy kalırsa ancak sırası gelince iner ve geçişte boş kare görünür.
          // Sayfa yüklendikten sonra düşük öncelikle önden indir; ilk görselle yarışmaz.
          if (document.readyState === 'complete') this.warmSlides();
          else window.addEventListener('load', this.warmSlides.bind(this), { once: true });

          this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));

          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

          this.start();
        }

        show(index) {
          const nextIndex = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === nextIndex;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
          });
          this.dots.forEach((dot, dotIndex) => {
            const active = dotIndex === nextIndex;
            dot.classList.toggle('is-active', active);
            if (active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.currentIndex = nextIndex;
          this.start();
        }

        start() {
          this.stop();
          if (this.dataset.autoplay !== 'true' || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = window.setInterval(() => this.show(this.currentIndex + 1), Number(this.dataset.interval) || 5000);
        }

        stop() {
          window.clearInterval(this.timer);
        }

        warmSlides() {
          this.querySelectorAll('[data-slide] img[loading="lazy"]').forEach((img) => {
            img.fetchPriority = 'low';
            img.loading = 'eager';
          });
        }

        disconnectedCallback() {
          this.stop();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["makri-instagram-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('makri-instagram-showcase')) {
    customElements.define(
      'makri-instagram-showcase',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.previous = this.querySelector('[data-previous]');
          this.next = this.querySelector('[data-next]');
          this.abortController = new AbortController();
          const signal = this.abortController.signal;

          this.previous.addEventListener('click', () => this.scroll(-1), { signal });
          this.next.addEventListener('click', () => this.scroll(1), { signal });
          this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        scroll(direction) {
          this.track.scrollBy({ left: this.track.clientWidth * 0.9 * direction, behavior: 'smooth' });
        }

        update() {
          const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
          this.previous.hidden = !hasOverflow;
          this.next.hidden = !hasOverflow;
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["makri-promo-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('makri-promo-showcase')) {
    customElements.define(
      'makri-promo-showcase',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.resizeObserver = new ResizeObserver(() => this.updateRows());
          this.querySelectorAll('[data-row]').forEach((row) => this.setupRow(row));
          this.updateRows();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        setupRow(row) {
          const track = row.querySelector('[data-track]');
          const previous = row.querySelector('[data-previous]');
          const next = row.querySelector('[data-next]');
          const signal = this.abortController.signal;

          previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.82, behavior: 'smooth' }), { signal });
          next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.82, behavior: 'smooth' }), { signal });
          track.addEventListener('scroll', () => this.updateRow(row), { signal, passive: true });
          this.resizeObserver.observe(track);
        }

        updateRows() {
          this.querySelectorAll('[data-row]').forEach((row) => this.updateRow(row));
        }

        updateRow(row) {
          const track = row.querySelector('[data-track]');
          const previous = row.querySelector('[data-previous]');
          const next = row.querySelector('[data-next]');
          const hasOverflow = track.scrollWidth > track.clientWidth + 2;
          previous.hidden = !hasOverflow;
          next.hidden = !hasOverflow;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
